<template>
  <div style="background:black;">
    <img style="width:100%; margin-top:56px;" v-bind:src="this.campaing">
  </div>
</template>
<script>
export default {
  name: "campaing",
  data(){
    return {
      campaing: [],
      sizes: [],
    }
  },
  methods: {
    getImagesSizes() {
      axios
          .get("api/file/get/banners")
          .then(res => {
            this.sizes = res.data.data;
            // console.log(this.sizes);
          })
          .catch(error => {
            console.log(error);
          });
    },
    getCampaing() {
      axios
          .get("api/file/get/banners/1")
          .then(res => {
            // console.log('res.data.data', res.data.data);
            this.campaing = res.data.data[0].files[0].url;
          })
          .catch(error => {
            console.log(error);
          });
    },
    // previousSize(index){
    //   if (this.campaing[index - 1])
    //     return "d-" + this.campaing[index - 1].size + "-none";
    //   else
    //     return "";
    // },
    // isMinimumSize(index){
    //   if ((index + 1) == this.campaing.length)
    //     return "dinamic-campaing";
    //   else
    //     return "dinamic-campaing d-none";
    // },
  },
  mounted() {
    this.getCampaing();
  }
}
</script>

<style>
@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>